import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Minimal styled range input used for the load "time machine" timeline slider.
 * (Radix slider is not installed; a styled native input keeps it dependency-free.)
 */
export type SliderProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Slider = React.forwardRef<HTMLInputElement, SliderProps>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      type="range"
      className={cn(
        "h-2 w-full cursor-pointer appearance-none rounded-full bg-muted accent-primary",
        className,
      )}
      {...props}
    />
  ),
);
Slider.displayName = "Slider";
